// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"3f656691","498":"b97939c9","513":"16979c0a","787":"9482929c"}[chunkId] + ".chunk.js";
};